import gql from 'graphql-tag';


export default gql`mutation {
    transfers {
        response
    }
}`



// WEBPACK FOOTER //
// ./src/graphql/mutations/transfers.mutation.js